export const btnPrimary =
  "inline-flex items-center justify-center gap-2 h-11 rounded-md px-8 text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg hover:shadow-xl transition-all duration-300 group";

export const btnOutline =
  "inline-flex items-center justify-center gap-2 h-11 rounded-md px-8 text-sm font-medium bg-background border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 group";

export const sectionHeading = "text-2xl md:text-3xl font-bold text-foreground mb-2";

export const iconCard =
  "rounded-lg border text-card-foreground shadow-sm p-6 bg-primary/5 border-primary/10 hover:bg-primary/10 transition-all duration-300";
